import React, { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';
import { formatFileSize } from '../../utils/formatFileSize';

function StatBlock({ label, value }) {
  return (
    <div className="system-info-stat">
      <span className="system-info-stat-value">{value}</span>
      <span className="system-info-stat-label">{label}</span>
    </div>
  );
}

function AdminSystemInfo() {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await api.get('/admin/system-info');
      setInfo(res.data);
    } catch (err) {
      setError('Failed to load system info.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading) return <div className="admin-loading">Loading system info...</div>;
  if (error)   return <div className="admin-error">{error}</div>;
  if (!info)   return null;

  return (
    <div className="admin-system-info">
      <div className="system-info-version">
        <span className="system-info-version-label">Version</span>
        <span className="system-info-version-value">{info.version}</span>
      </div>

      <h3 className="system-info-section-heading">Recordings</h3>
      <div className="system-info-stats-grid">
        <StatBlock label="Total Recordings"     value={info.totalRecordings.toLocaleString()} />
        <StatBlock label="Last 7 Days"          value={info.recordingsLast7Days.toLocaleString()} />
        <StatBlock label="Total Storage Used"   value={formatFileSize(info.totalStorageBytes)} />
      </div>

      <h3 className="system-info-section-heading">Users</h3>
      <div className="system-info-stats-grid">
        <StatBlock label="Total Users"          value={info.totalUsers.toLocaleString()} />
        <StatBlock label="Active Last 7 Days"   value={info.activeUsersLast7Days.toLocaleString()} />
        <StatBlock label="New Last 7 Days"      value={info.newUsersLast7Days.toLocaleString()} />
      </div>

      <button className="btn btn-secondary system-info-refresh" onClick={load}>
        Refresh
      </button>
    </div>
  );
}

export default AdminSystemInfo;
